import {
  Box,
  Typography,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
} from "@mui/material";
import {
  getInstrumentsData,
  getPortfolioData,
  getServicesData,
  tableColumns,
} from "./utils";
import { useGetSecuritiesInfo } from "src/queries/useGetSecuritiesInfo";
import { useInputContext } from "src/contexts";
import { getNameFromInput } from "src/utils/functions";
import { styles } from "../styles";
import { ServiceNameCellContent } from "../ServicesTable";

const NameCellContent = ({
  isinIn,
  serviceIn,
}: {
  isinIn: string;
  serviceIn: string;
}) => {
  const { inputItems } = useInputContext();
  const { data } = useGetSecuritiesInfo({ isinIn, serviceIn });
  return (
    <span>
      {data
        ? data[0]?.name ||
          getNameFromInput({
            productId: isinIn,
            serviceId: serviceIn,
            input: inputItems,
          })
        : "--"}
    </span>
  );
};

export const PerformanceTable = ({
  data,
  filteredType,
}: {
  data: any;
  filteredType: string | number | undefined;
}) => {
  const { sortedItems } = useInputContext();
  const shownItems = filteredType ? sortedItems[filteredType] : [];
  const serviceIDs = filteredType
    ? sortedItems[filteredType].map((item) => item.serviceID)
    : [];

  return (
    <Box>
      <Typography sx={styles.title}>Výkonnost</Typography>
      <Table sx={styles.table} aria-label="simple table">
        <TableHead sx={styles.tableHeaderRow}>
          <TableRow>
            {Object.keys(tableColumns).map((key) => (
              <TableCell
                key={key}
                component="th"
                scope="row"
                sx={styles.tableHeader}
              >
                {tableColumns[key as keyof typeof tableColumns]}
              </TableCell>
            ))}
          </TableRow>
        </TableHead>
        <TableBody>
          <TableRow>
            {Object.keys(tableColumns).map((key) => {
              const instrumentData = getPortfolioData(data) || {};
              return (
                <TableCell key={`portfolio-${key}`} component="th" scope="row">
                  {key === "name"
                    ? "Portfolio celkem"
                    : instrumentData[key as keyof typeof instrumentData]}
                </TableCell>
              );
            })}
          </TableRow>
          {data.byServices.map((service: any) => {
            return filteredType &&
              !serviceIDs.includes(service.serviceId) ? null : (
              <TableRow key={service.serviceId}>
                {Object.keys(tableColumns).map((key) => {
                  const instrumentData = getServicesData(service) || {};
                  return (
                    <TableCell
                      key={`${service.serviceId}-${key}`}
                      component="th"
                      scope="row"
                    >
                      {key === "name" ? (
                        <ServiceNameCellContent
                          serviceIn={
                            instrumentData[key as keyof typeof instrumentData]
                          }
                        />
                      ) : (
                        instrumentData[key as keyof typeof instrumentData]
                      )}
                    </TableCell>
                  );
                })}
              </TableRow>
            );
          })}
          {data.byServices.map((service: any) =>
            service.byProducts.map((product: any) =>
              filteredType &&
              !shownItems.some(
                (item) =>
                  item.productID === product.productId &&
                  item.serviceID === service.serviceId
              ) ? null : (
                <TableRow key={`${service.serviceId}-${product.productId}`}>
                  {Object.keys(tableColumns).map((key) => {
                    const instrumentData = getInstrumentsData(product) || {};
                    return (
                      <TableCell
                        key={`${service.serviceId}-${product.productId}-${key}`}
                        component="th"
                        scope="row"
                      >
                        {key === "name" ? (
                          <NameCellContent
                            isinIn={
                              instrumentData[key as keyof typeof instrumentData]
                            }
                            serviceIn={service.serviceId}
                          />
                        ) : (
                          instrumentData[key as keyof typeof instrumentData]
                        )}
                      </TableCell>
                    );
                  })}
                </TableRow>
              )
            )
          )}
        </TableBody>
      </Table>
    </Box>
  );
};
